import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from '../../../../components/Link'
import { Defer } from 'react-progressive-loader'
import skeletonFade from '../../../../modules/mixins/skeleton-fade'

const Wrapper = styled(Link)`
  display: block;
`
const InnerWrapper = styled.div`
  position: relative;
  display: block;
  margin-top: ${(props) => props.theme.sizes.gapVertical};
  margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  width: 980px;
  padding-top: 32.95918%;
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.tablet.sizes.gapVertical};
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-top: ${(props) => props.theme.mobile.sizes.gapVertical};
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
    width: 600px;
    padding-top: 65.5%;
  }
`

const BannerNaked = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`

const BannerSkeleton = styled(BannerNaked)`
  background-color: ${(props) => props.theme.color.skeletonScreen};
  ${skeletonFade};
`

const BannerImage = styled(BannerNaked)`
  background-size: contain;
  background-repeat: no-repeat;
  background-image: url(${(props) => props.imageLarge});

  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    background-image: url(${(props) => props.imageSmall});
  }
`

const BannerBlock = ({ imageSmall, imageLarge, url, ...props }) => (
  <Wrapper to={url} {...props}>
    <InnerWrapper>
      <Defer
        render={() => <BannerImage imageSmall={imageSmall} imageLarge={imageLarge} />}
        renderPlaceholder={() => <BannerSkeleton />}
        loadOnScreen
      />
    </InnerWrapper>
  </Wrapper>
)

BannerBlock.propTypes = {
  imageSmall: PropTypes.string,
  imageLarge: PropTypes.string,
  url: PropTypes.string,
}

export default BannerBlock
